<template>
    <BreadCrumb PageTitle="Page Récapitulative du BESC - Étape 4/4" />
    <Recapitulatif />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Recapitulatif from "@/components/BESC/AddBesc/Recapitulatif.vue";

export default defineComponent({
    name: "RecapitulatifPage",
    components: {
        BreadCrumb,
        Recapitulatif,
    },
});
</script>